import React from 'react';
import {
  Bar,
  BarItem,
  Container,
  Section,
  Skeleton,
} from '../../../../components/';
import { propTypes } from '../../../../components/Section/Section';

export const BlogContainer = ({ children, narrow, spaceTop, spaceBottom }) => (
  <Container className={narrow ? 'blog__container' : ''}>
    <Section spaceTop={spaceTop} spaceBottom={spaceBottom}>
      {children}
    </Section>
  </Container>
);
BlogContainer.propTypes = propTypes;

const SinglePostSkeleton = () => (
  <React.Fragment>
    <BlogContainer narrow>
      <h2 className="font-family-clearface blog__heading">
        <Skeleton />
        <Skeleton maxWidth="50%" />
      </h2>
      <p className="blog__leading-paragraph">
        <Skeleton />
        <Skeleton maxWidth="75%" />
        <Skeleton maxWidth="50%" />
      </p>
      <Bar space="small" align="middle" className="mb-none">
        <BarItem>
          <Skeleton width="48px" height="48px" isCircle />
        </BarItem>
        <BarItem>
          <small>
            <Skeleton width="100px" />
            <Skeleton maxWidth="90%" />
          </small>
        </BarItem>
      </Bar>
    </BlogContainer>
    <Skeleton height="100%" />
    <BlogContainer>
      <Skeleton width="100%" height="1000px" />
    </BlogContainer>
  </React.Fragment>
);

export default SinglePostSkeleton;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/SinglePost/SinglePostSkeleton.js